/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Favorite_RemovedInputs */

const en_us2_exercise_personal_favorite_removed = /** @type {(inputs: Exercise_Personal_Favorite_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Removed from favourites`)
};

const pt_br2_exercise_personal_favorite_removed = /** @type {(inputs: Exercise_Personal_Favorite_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tirado dos favoritos`)
};

const es_419_exercise_personal_favorite_removed = /** @type {(inputs: Exercise_Personal_Favorite_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitado de favoritos`)
};

const pt_pt2_exercise_personal_favorite_removed = /** @type {(inputs: Exercise_Personal_Favorite_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirado dos favoritos`)
};

const fr_fr2_exercise_personal_favorite_removed = /** @type {(inputs: Exercise_Personal_Favorite_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retiré des favoris`)
};

const de_de2_exercise_personal_favorite_removed = /** @type {(inputs: Exercise_Personal_Favorite_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus Favoriten entfernt`)
};

const it_it2_exercise_personal_favorite_removed = /** @type {(inputs: Exercise_Personal_Favorite_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimosso dai preferiti`)
};

/**
* | output |
* | --- |
* | "Removed from favourites" |
*
* @param {Exercise_Personal_Favorite_RemovedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_favorite_removed = /** @type {((inputs?: Exercise_Personal_Favorite_RemovedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Favorite_RemovedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_favorite_removed(inputs)
	if (locale === "es-419") return es_419_exercise_personal_favorite_removed(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_favorite_removed(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_favorite_removed(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_favorite_removed(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_favorite_removed(inputs)
	return en_us2_exercise_personal_favorite_removed(inputs)
});
export { exercise_personal_favorite_removed as "exercise-personal.favorite_removed" }